<router-outlet></router-outlet>
<mag-loading-indicator></mag-loading-indicator>
